export const styles = () => ({
  emailInput: {
    width: "100%",
  },
  formWrapper: {
    alignItems: "center",
    display: "flex",
    gridGap: "1rem",
    marginBottom: "2rem",
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/administrators/styles.ts